<template>
  <section class="apps" aria-labelledby="apps-title">
    <div class="shell apps-grid">
      <div v-reveal class="apps-copy">
        <h2 id="apps-title">Mobile apps your customers will actually use</h2>
        <p>
          iOS and Android apps connected to your systems, so customers can
          book, track and pay from their phones, and your team sees it all in
          one place.
        </p>
        <ul class="apps-points">
          <li>Built on the same back end as your website and tools</li>
          <li>Updates and alerts by push notification, SMS or WhatsApp</li>
          <li>Tested on real devices before launch</li>
        </ul>
        <a
          class="btn btn-primary btn-icon"
          :href="contact.whatsappUrl"
          target="_blank"
          rel="noopener noreferrer"
          ><WhatsAppIcon />Ask about an app<span class="sr-only">
            (opens WhatsApp)</span
          ></a
        >
      </div>
      <figure v-reveal class="apps-visual">
        <AppScreens />
        <figcaption>Example screens</figcaption>
      </figure>
    </div>
  </section>
</template>

<script>
import AppScreens from "@/components/graphics/AppScreens.vue";
import WhatsAppIcon from "@/components/graphics/WhatsAppIcon.vue";
import contact from "@/config/contact";

export default {
  name: "AppsSection",
  components: { AppScreens, WhatsAppIcon },
  data: () => ({ contact }),
};
</script>
